module.exports = __webpack_public_path__ + "img/m1-screenshot-01.07fd484b.png";